<template>
  <div class="md-layout">
    <div
      class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
    >
      <md-card-conten>
        <Resumen></Resumen>
      </md-card-conten>

      <md-card class="md-card-plain">
        <md-card-header data-background-color="green">
          <h4 class="title">Caja</h4>
        </md-card-header>
        <md-card-content>
          <ordered-table></ordered-table>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import { OrderedTable } from "@/components";
import Resumen from "../components/caja/Resumen.vue";

export default {
  components: {
    OrderedTable,
    Resumen
  }
};
</script>
